import { useHistory } from 'react-router-dom';
import { OSBPathFindBookingStep } from '../../components/sections/osb-v3/osb-view-controller';
import { useOSBStep } from '../owners-osb';

export const useBookingLookupProps = () => {
    const { osbStep } = useOSBStep();
    const history = useHistory();

    const handleTrigger = () => {
        history.push(OSBPathFindBookingStep(), osbStep.UrlQueryParams);
    };

    return {
        onTrigger: handleTrigger,
    };
};
